import { get, post, put, deleted, downloadFilePost } from 'utils/api';
import { DataResponse } from '../response';
import { MASTER_DATA_API_URL } from 'utils/constants';

export type WasteGroupingEnvironmentPermitModel = {
  wasteGroupingEnvironmentPermitId?: string;
  wasteGroupingContractId?: string;
  wasteGroupingContractName?: string;
  wasteGroupingEnvironmentPermitCustomCode?: string;
  wasteGroupingEnvironmentPermitName?: string;
  quantity?: number;
  year?: number;
  effectiveDate?: string;
  unit?: string;
  unitName?: string;
  createBy?: string;
  userName?: string;
  createTime?: string;
  isDisplayCodeInReport?: boolean;
  actived?: boolean;
  wasteGroup?: string;
  stt?: number;
  wasteGroupingEnvironmentPermitLogs?: WasteGroupingEnvironmentPermitLog[];
};

export type WasteGroupingEnvironmentPermitLog = {
  wasteGroupingEnvironmentPermitLogId?: string;
  wasteGroupingEnvironmentPermitId?: string;
  oldQuantity?: number;
  oldYear?: number;
  oldUnit?: string;
  oldUnitName?: string;
  newQuantity?: number;
  newYear?: number;
  newUnit?: string;
  newUnitName?: string;
  oldCreateBy?: string;
  oldUserName?: string;
  oldCreateTime?: string;
  createBy?: string;
  userName?: string;
  createTime?: string;
};

export type WasteGroupingEnvironmentPermitSearchPayload = {
  wasteGroupingEnvironmentPermitCustomCode?: string;
  wasteGroupingEnvironmentPermitName?: string;
  wasteGroup?: string;
  wasteGroupingContractId?: string;
  wasteGroupingContractIds?: string[];
  actived?: boolean;
  activedOnly?: boolean;
  paging?: {
    pageSize?: number;
    pageIndex?: number;
    orderBy?: string;
    orderByDesc?: string;
  };
};

export type WasteGroupingEnvironmentPermitExportPayload = {
  wasteGroupingEnvironmentPermitCustomCode?: string;
  wasteGroupingEnvironmentPermitName?: string;
  wasteGroup?: string;
  wasteGroupingContractId?: string;
  wasteGroupingContractIds?: string[];
  actived?: boolean;
};

export interface IWasteGroupingEnvironmentPermitServices {
  searchWasteGroupingEnvironmentPermits(
    payload: WasteGroupingEnvironmentPermitSearchPayload
  ): Promise<DataResponse<WasteGroupingEnvironmentPermitModel[]>>;

  createWasteGroupingEnvironmentPermit(
    payload: WasteGroupingEnvironmentPermitModel
  ): Promise<DataResponse<any>>;

  updateWasteGroupingEnvironmentPermit(
    payload: WasteGroupingEnvironmentPermitModel
  ): Promise<DataResponse<any>>;

  getDetailWasteGroupingEnvironmentPermit(
    id: string
  ): Promise<DataResponse<WasteGroupingEnvironmentPermitModel>>;

  deleteWasteGroupingEnvironmentPermit(
    id: string
  ): Promise<DataResponse<any>>;

  exportTemplateCreate(payload: WasteGroupingEnvironmentPermitExportPayload): Promise<void>;

  importWasteGroupingEnvironmentPermit(
    file: File
  ): Promise<DataResponse<any>>;

  exportTemplateAdd(payload?: WasteGroupingEnvironmentPermitExportPayload): Promise<void>;

  importWasteGroupingEnvironmentPermitCreate(
    file: File
  ): Promise<DataResponse<any>>;
}

export const createWasteGroupingEnvironmentPermitServices = (): IWasteGroupingEnvironmentPermitServices => {
  return {
    searchWasteGroupingEnvironmentPermits: async (payload) => {
      return (await post(MASTER_DATA_API_URL, 'wastegroupingenvironmentpermit/search', payload)).data;
    },

    createWasteGroupingEnvironmentPermit: async (payload) => {
      return (await post(MASTER_DATA_API_URL, 'wastegroupingenvironmentpermit/create', payload)).data;
    },

    updateWasteGroupingEnvironmentPermit: async (payload) => {
      return (await put(MASTER_DATA_API_URL, 'wastegroupingenvironmentpermit/update', payload)).data;
    },

    getDetailWasteGroupingEnvironmentPermit: async (id) => {
      return (await get(MASTER_DATA_API_URL, `wastegroupingenvironmentpermit/get/${id}`)).data;
    },

    deleteWasteGroupingEnvironmentPermit: async (id) => {
      return (await deleted(MASTER_DATA_API_URL, `wastegroupingenvironmentpermit/delete/${id}`)).data;
    },

    exportTemplateCreate: async (payload) => {
      await downloadFilePost(MASTER_DATA_API_URL, 'wastegroupingenvironmentpermit/export-template-create', payload);
    },

    importWasteGroupingEnvironmentPermit: async (file) => {
      const formData = new FormData();
      formData.append('file', file);
      return (await post(MASTER_DATA_API_URL, 'wastegroupingenvironmentpermit/import', formData)).data;
    },

    exportTemplateAdd: async (payload) => {
      // API backend thường yêu cầu body JSON (dù rỗng). Tránh gửi undefined gây 415.
      await downloadFilePost(
        MASTER_DATA_API_URL,
        'wastegroupingenvironmentpermit/export-template-add',
        (payload ?? ({} as any)) as any
      );
    },

    importWasteGroupingEnvironmentPermitCreate: async (file) => {
      const formData = new FormData();
      formData.append('file', file);
      return (await post(MASTER_DATA_API_URL, 'wastegroupingenvironmentpermit/import-create', formData)).data;
    },
  };
};

